import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { exchangeGoogleSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    const finish = () => {
      window.history.replaceState(null, "", window.location.pathname);
      navigate("/", { replace: true });
    };
    if (!sessionId) {
      finish();
      return;
    }
    exchangeGoogleSession(sessionId)
      .then((u) => toast.success(`Welcome, ${u.name || u.email}`))
      .catch(() => toast.error("Google sign-in failed. Please try again."))
      .finally(finish);
  }, [location.hash, navigate, exchangeGoogleSession]);

  return (
    <div className="flex min-h-screen items-center justify-center" data-testid="auth-callback-loading">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
};
